/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'dull',
    quality: 0,
    learning: -1,
	mana: -1,
	dexterity: -1
}